<app-breadcrumb [title]="'CMS Pages'"></app-breadcrumb>
<div class="container-fluid">
  <div class="row">
    <div class="col">
      <div class="card mb-3">
        <div class="card-header">
          <div class="d-flex justify-content-between align-items-center">
            <h3 class="h6 fw-weight mb-0">{{ title }}</h3>
            <a routerLink="/admin/cms-pages" class="btn btn-outline-primary rounded-0">Cancel</a>
          </div>
        </div>
        <div class="card-body">
          <form [formGroup]="cmsPageForm" (ngSubmit)="save()">
            <input type="hidden" formControlName="id">
            <input type="hidden" formControlName="mediaFileThumbId">
            <div class="row">
              <div class="col-md-4">
                <div class="form-group mb-3">
                  <label class="form-label" for="parentCmsPageId">Parent Menu Content</label>
                  <select MyInput formControlName="parentCmsPageId" class="form-select">
                    <option value="" selected>--SELECT--</option>
                    <option *ngFor="let item of cmsPages" value="{{ item.id }}">{{ item.title }}
                    </option>
                  </select>
                </div>
                <div class="form-group mb-3">
                  <label class="form-label" for="title">Title</label>
                  <input MyInput formControlName="title" id="title" type="text" class="form-control">
                  <my-error controlName="title" errorKey="required">title is required.</my-error>
                </div>
                <div class="form-group mb-3">
                  <label class="form-label" for="slug">Slug</label>
                  <input MyInput formControlName="slug" id="slug" type="text" class="form-control">
                  <my-error controlName="slug" errorKey="required">slug is required.</my-error>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group mb-3">
                  <div class="form-check">
                    <input type="checkbox" MyInput formControlName="isCommingSoon" class="form-check-input"
                      id="isCommingSoon">
                    <label class="form-check-label" for="isCommingSoon">Is Coming Soon?</label>
                  </div>
                  <my-error controlName="isCommingSoon" errorKey="required">Is Coming Soon? is required.</my-error>
                </div>
                <div class="border p-2">
                  <div class="row">
                    <div class="col-md-8">
                      <div class="form-file">
                        <input class="form-file-input" type="file" #inputDoc
                          (change)="handleFileInput($event.target.files);OnSubmit(inputDoc)">
                        <label class="form-file-label" for="customFile">
                          <span class="form-file-text">Choose file...</span>
                          <span class="form-file-button">Browse</span>
                        </label>
                      </div>
                      <my-error controlName="mediaFileThumbId" errorKey="required">File is required.</my-error>
                    </div>
                    <div class="col-md-4 mt-2" *ngIf="cmsPage">
                      <a target="_blank" [attr.href]="cmsPage.mediaFileThumb?.mediaUrl"
                        class="btn btn-primary">Uploaded
                        Document</a>
                    </div>
                  </div>
                  <div id="progress-avatar" class="progress progress-xs" [class.fade]="!isProgress">
                    <div [style.width]="barWidth + '%'"
                      class="progress-bar progress-bar-striped progress-bar-animated bg-success" role="progressbar"
                      aria-valuemin="0" aria-valuemax="100"></div>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group mb-3">
                  <label for="content">Content</label>
                  <div class="col-md-12 px-0">
                    <angular-editor formControlName="content" [config]="editorConfigOption"></angular-editor>
                  </div>
                  <my-error controlName="content" errorKey="required">content is required.</my-error>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-end mt-5">
              <button class="btn btn-primary rounded-0 mr-2" [disabled]="!cmsPageForm.valid || loading"
                (click)="savePreview()" type="button">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="loading"></span>
                Save & Preview
              </button>
              <button class="btn btn-primary rounded-0 mr-2" [disabled]="!cmsPageForm.valid || loading" type="submit">
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="loading"></span>
                Submit
              </button>
              <button *ngIf="id" type="button" (click)="delete()" class="btn btn-danger rounded-0">Delete</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>